import { IsiCallerType, IsiDtoPlSuggestRequest, IsiDtoPlSuggestResponse } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlSuggest";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlSuggest extends IsiPresentationLogic {

    constructor() {
        super("IsiPlSuggestHandler");
    }

    /**
     * Retourne les écrans liste disponible pour un controle connexe
     */
    public async GetAvailableScreenList(controlId: string, callerType: IsiCallerType, mainControlId: string): Promise<IsiDtoPlSuggestResponse> {
        let params = IsiDtoPlSuggestRequest.fromJS({
            callerType: callerType,
            controlId: controlId,
            mainControlID: mainControlId,
            response: IsiDtoPlSuggestResponse.fromJS({})
        });

        const result: IIsiUIFlowResultGeneric<IsiDtoPlSuggestRequest> = await this.ajaxWithErrorHandling("GetAvailableScreenList", params, true);

        return result?.reponse?.response;
    }


    /**
     * Retourne la liste de valeur d'un connexe
     */
    public async GetConnexeValues(controlId: string, mainControlId: string, action: string, fieldValue: string, linkedCtrl: any, controlType: number): Promise<IsiDtoPlSuggestResponse> {
        let params = IsiDtoPlSuggestRequest.fromJS({
            controlId: controlId,
            mainControlID: mainControlId,
            actionType: action,
            fieldValue: fieldValue,
            linkedCtrlFilter: linkedCtrl,
            ctrlType: controlType,
            response: IsiDtoPlSuggestResponse.fromJS({
            })
        });

        const result: IIsiUIFlowResultGeneric<IsiDtoPlSuggestRequest> = await this.ajaxWithErrorHandling("GetConnexeValues", params, true);

        return result?.reponse?.response;
    }
}
